import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
const useStyles = createUseStyles((_) => ({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
    // On mobile the Sidebar content area owns the scroll.
    "@media (max-width:899.95px)": {
      overflow: "visible",
      height: "auto",
      minHeight: "var(--app-vh)",
    },
  },
  vehiculeRoot: {
    overflowY: "auto",
    overflowX: "hidden",
    padding: "20px clamp(16px, 3vw, 30px)",
    height: "var(--app-vh)",
    minWidth: 0,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": {
      paddingTop: "68px",
      height: "auto",
      minHeight: "var(--app-vh)",
      overflowY: "visible",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    flex: "1 1 auto",
    minHeight: 0,
    minWidth: 0,
    "@media (max-width:599.95px)": { gap: "18px" },
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "15px",
    width: "100%",
    minWidth: 0,
    // Title cell shrinks; the two nowrap buttons keep their intrinsic width.
    "& > div:first-child": { minWidth: 0, flex: "1 1 auto" },

    "@media (max-width:899.95px)": {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "12px",
      "& > div:first-child": { flex: "0 0 auto" },
    },
    "@media (max-width:599.95px)": {
      // 30px / 47px line-height broke the title onto one word per line.
      "& > div:first-child > div": { fontSize: "22px", lineHeight: "28px" },
    },
  },
  subContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "35px",
    // Fill whatever is left below the header instead of assuming a fixed
    // 140px header height (it is much taller once the header wraps).
    flex: "1 1 auto",
    minHeight: 0,
    minWidth: 0,
    overflow: "auto",
    "@media (max-width:899.95px)": {
      // One page-level scroller on touch devices, no nested one.
      flex: "0 0 auto",
      overflow: "visible",
      gap: "24px",
    },
  },

  divbuttonHeader: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "15px",
    flexShrink: 0,
    "@media (max-width:899.95px)": { width: "100%" },
    "@media (max-width:599.95px)": {
      flexDirection: "column",
      gap: "10px",
      "& .MuiButton-root": { width: "100% !important" },
    },
  },
}));

export default useStyles;
